<template>
    <div id="app-login" class="d-flex flex-row align-items-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-sm-11 col-md-10 col-lg-8 col-xl-7">
                    <div class="card-group main-card shadow-lg">
                        <div id="login__card--left" class="card text-white py-4">
                            <div class="card-body text-center d-flex flex-column justify-content-center align-items-center">
                                <div class="login-left-container">
                                    <div class="logo-container mb-4">
                                        <img id="login__logo" src="assets/images/Logo_Elroble.png" alt="El Roble" class="login-logo">
                                    </div>
                                    
                                    <div class="login-image-container">
                                        <img src="assets\images\loginCobros.png" class="login-image" alt="Login COBROS">
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div id="login__card--right" class="card p-3">
                            <div class="card-body text-center py-2">
                                <h1>Pagos <br> El Roble</h1>
                                <div class="mt-2">
                                    <h4 class="text-primary">
                                        Iniciar sesión
                                    </h4>
                                </div>
                                <p class="text-medium-emphasis mt-3">Ingresa tus credenciales para acceder</p>
                                
                                <div class="form mt-3">
                                    <div class="form-group mb-3">
                                        <input 
                                            class="form-control" 
                                            type="email" 
                                            placeholder="Correo electrónico" 
                                            required 
                                            v-model="correo"
                                        >
                                    </div>
                                    <div class="form-group mb-4">
                                        <input 
                                            class="form-control" 
                                            type="password" 
                                            placeholder="Contraseña" 
                                            required 
                                            v-model="password"
                                            @keyup.enter="login"
                                        >
                                    </div>
                                    
                                    <div class="text-danger mb-4" v-if="msg !== ''">{{msg}}</div>
                                    
                                    <div class="form-group">
                                        <button 
                                            class="btn btn-primary btn-block w-100" 
                                            type="button" 
                                            @click="login"
                                            id="login__button"
                                            :disabled="procesando"
                                        >
                                            <span v-if="procesando">Iniciando sesión...</span>
                                            <span v-else>Iniciar sesión</span>
                                        </button>
                                    </div>
                                    
                                    <div class="form-group mt-3 text-center text-muted small">
                                        Seguros El Roble 2026 - V.{{version}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Layout from "../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import {mapGetters, mapMutations} from "vuex";
import {store} from "src/store";
import AndroidBridge from "src/core/AndroidBridge";
import {CONFIG} from "src/config";

export default {
    props: {
    },
    components: {
        //TimelineChart,
        Layout,
        //Toster,
    },
    data() {
        return {
            androidBridge: false,
            msg: "",
            correo: "",
            password: "",
            version: "",
            procesando: false,
        };
    },
    mounted() {
        this.version = CONFIG.getVersion();
        this.androidBridge = new AndroidBridge();
        this.androidBridge.enablePressBackToOut('http://localhost/login');
    },
    methods: {
        ...mapGetters(["AuthIsLogged"]),
        ...mapMutations(["AuthSetToken", "SetUserInfo"]),
        login() {

            const self = this;

            if (self.procesando) {
                return;
            }

            if (!Tools.isEmptyString(this.correo) && !Tools.isEmptyString(this.password)) {
                self.procesando = true;
                API.send('POST', 'auth/login', {
                        "usuario": self.correo,
                        "contrasenia": self.password,
                    },
                    function (response) {
                        if (typeof response.status !== 'undefined' && response.status === 1) {

                            self.AuthSetToken(response.data);
                            self.SetUserInfo({
                                correo: self.correo,
                                perfil: response.perfil,
                                c: (typeof response.c !== 'undefined') ? response.c : {},
                            });

                            if (self.AuthIsLogged()) {
                                //store.dispatch('coreHideLoading');
                                self.$router.push('/menu');
                            }
                        }
                        else {
                            self.msg = 'Usuario o contraseña incorrectos';
                        }
                        self.procesando = false;
                    },
                    function () {
                        self.msg = 'Error de conexión, por favor intente de nuevo';
                        self.procesando = false;
                    },
                    {singleFlight: true})
            }
            else {
                self.msg = 'Ingrese un correo electrónico válido';
            }
        },
    },
};
</script>

<style scoped>
    
#app-login {
    background-color: var(--first-background-color) !important;
    min-height: 100vh;
    padding: 2rem 0;
}

.main-card {
    border-radius: 8px;
    overflow: hidden;
}

/* En pantallas pequeñas ajustar padding */
@media (max-width: 600px) {
    #app-login {
        padding: 1rem 0;
    }
}

#login__card--left {
    background-color: #002755 !important;
    border: none;
}

#login__card--right {
    border: none;
}

#login__card--right h4 {
    color: #043B67 !important;
}

#login__card--right h1 {
    color: #00B8D3 !important;
}

#login__card--right p {
    color: var(--first-button-color) !important;
}

#login__button {
    background-color: var(--first-button-color);
    border-color: var(--first-button-color);
    padding: 0.75rem 1.5rem;
    font-weight: 500;
}

#login__button:hover {
    background-color: #00294a;
    border-color: #00294a;
}

#login__card--left {
    padding: 1.5rem;
}

#login__card--right .card-body {
    padding: 1rem;
}

.text-medium-emphasis {
    color: rgba(0, 0, 0, 0.6);
}

 .login-left-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    
    .logo-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .logo-container span {
        color: #ffffff;
        font-size: 2rem;
        font-weight: bold;
        margin-left: 0.5rem;
    }
    
    .login-logo {
        max-width: 200px;
        width: 80%;
        height: auto;
    }
    
    .login-image-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 2rem;
    }
    
    .login-image {
        max-width: 100%;
        width: 100%;
        height: auto;
        object-fit: contain;
    }
    
    
    /* Pantallas grandes - mantener tamaño estándar */
    @media (min-width: 991px) {
        .login-logo {
            max-width: 200px;
        }
        
        .login-image {
            max-width: 100%;
        }
    }
    
    /* Rango 770-990px - optimizar espacio horizontal */
    @media (min-width: 770px) and (max-width: 990px) {
        .login-logo {
            max-width: 180px;
        }
        
        .login-image-container {
            margin-top: 1rem;
        }
        
        .login-image {
            max-width: 85%;
        }
        
        #login__card--left .card-body {
            padding: 1.5rem;
        }
    }
    
    /* Móviles - reducir tamaño significativamente */
    @media (max-width: 575px) {
        .login-logo {
            max-width: 100px;
        }
        
        .logo-container {
            margin-bottom: 1rem !important;
        }
        
        .login-image-container {
            margin-top: 0.5rem;
        }
        
        .login-image {
            max-width: 70%;
        }
        
        #login__card--left .card-body,
        #login__card--right .card-body {
            padding: 1rem;
        }
        
        #login__card--right h1 {
            font-size: 2rem;
        }
    }
</style>